import React, { useState, useEffect } from 'react'
import axios from "../url-access/axios";
import './main.css';
import YouTube from 'react-youtube'
import movieTrailer from "movie-trailer"

const Row = (props) => {
  // console.log(props.title);
  // console.log(props.fetchUrl);
  const [movies, setMovies] = useState([]);

  // to fetch the url using axios
  useEffect(() => {
    async function fetchData() {
      const request = await axios.get(props.fetchUrl);
      // console.log(request);
      setMovies(request.data.results)
      return request;
    }
    fetchData();
  }, [props.fetchUrl]);

  // console.log(movies);
  const YoutubeStyle = {
    height: '390',
    width: '640',
    playerVars: { autoplay: 1, }
  };
  const [trailerURL, setTrailerURL] = useState("");
  const PlayTrailer = (movie) => {
    // console.log(movie);
    if (trailerURL) {
      setTrailerURL("");
    } else {
      console.log(movie?.title || movie?.name || movie?.original_name)
      movieTrailer(movie?.title || movie?.name || movie?.original_name)
        .then((url) => {
          // console.log("url", url)
          const urlParams = new URLSearchParams(new URL(url).search);
          setTrailerURL(urlParams.get("v"))
        })
        .catch((error) => console.log(error));
    }
  };
  const EndPlayTrailer = () => {
    if (trailerURL) {
      setTrailerURL("");
    } else {
      console.log("TrailerURL",trailerURL);
    }
  };


  return (
    <>
      <div className="movie-lists" onClick={() => EndPlayTrailer()}>
        <h2>{props.title}</h2>
        <div className="posters-row">
          {movies.map(movie => (
            <img
              key={movie.id}
              onClick={() => PlayTrailer(movie)}
              className={`image-in-row ${props.isLargeRow && "image-in-row-large"}`}
              src={`https://image.tmdb.org/t/p/w200${props.isLargeRow ? movie.poster_path : movie.backdrop_path}`}
              alt={movie.name}
            />
          ))}
        </div>
        <div className="movie-player">
          {trailerURL && <YouTube videoId={trailerURL} opts={YoutubeStyle} />}
        </div>

      </div>
    </>
  )
}

export default Row